module.exports = __webpack_public_path__ + "static/media/rounded-arrow-disabled.dd29fd63.svg";